module.exports = __webpack_public_path__ + "img/yq-pic5.e7a926bd.png";